import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import { api } from "../../lib/api";
import { ROLE_LABELS } from "../../lib/auth";

export default function AdminUsersList() {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  async function load() {
    try {
      setUsers(await api("/api/admin/admin-users"));
    } catch (err) {
      setError(err.message);
    }
  }

  useEffect(() => { load(); }, []);

  return (
    <AdminLayout title="Admin Users" subtitle="Manage CMS administrators and their access levels." actions={<Link to="/adxm/admin-users/create" className="rounded-xl bg-emerald-700 px-4 py-2 text-sm font-bold text-white">Add Admin</Link>}>
      {error && <div className="mb-4 rounded-xl bg-red-50 p-4 font-semibold text-red-700">{error}</div>}
      <div className="overflow-x-auto rounded-3xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="w-full text-left text-sm">
          <thead className="bg-slate-100 text-xs uppercase tracking-wider text-slate-600"><tr><th className="p-4">Name</th><th className="p-4">Email</th><th className="p-4">Role</th><th className="p-4">Status</th><th className="p-4">Last Login</th><th className="p-4">Actions</th></tr></thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.id} className="border-t border-slate-100">
                <td className="p-4 font-bold">{user.name}</td>
                <td className="p-4">{user.email}</td>
                <td className="p-4"><span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-black text-slate-700">{ROLE_LABELS[user.role] || user.role}</span></td>
                <td className="p-4"><span className={user.status === "active" ? "rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold text-emerald-700" : "rounded-full bg-red-100 px-3 py-1 text-xs font-bold text-red-700"}>{user.status}</span></td>
                <td className="p-4">{user.last_login_at ? new Date(user.last_login_at).toLocaleString() : "Never"}</td>
                <td className="p-4"><Link to={`/adxm/admin-users/edit/${user.id}`} className="font-bold text-emerald-700">Edit</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
